import Paper, { type PaperProps } from '@mui/material/Paper';
import {
  dashboardAccentPanelSx,
  dashboardSectionPanelSx,
} from '@/shared/styles/surfaces';

type GuideDashboardCardTone = 'default' | 'accent';

export type GuideDashboardCardProps = Omit<PaperProps, 'variant'> & {
  tone?: GuideDashboardCardTone;
};

export function GuideDashboardCard({
  tone = 'default',
  sx,
  ...props
}: GuideDashboardCardProps) {
  const baseSx = tone === 'accent' ? dashboardAccentPanelSx : dashboardSectionPanelSx;

  return (
    <Paper
      elevation={0}
      sx={[
        baseSx,
        { height: '100%' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...props}
    />
  );
}
